import React, {useEffect, useState} from 'react';
import CareersAdItem from 'app/Components/Page/CellcomCareersPage/Shared/Utils/CareersAdItem/CareersAdItem';
import CheckboxDropdown from 'app/Components/Shared/SelectWithCheckBox/CheckboxDropdown';
import LocationJobIcon from '../Utils/Img/LocationJob.svg';
import ScopeJobIcon from '../Utils/Img/ScopeJob.svg';

const CareersAd = ({
  context,
                     cities, adsCareersData,
  filterJobData,
  careerScopeList,
  locationCareersData,
  updateLocation,
  updateScope,
  selectedUtils,
  setCollapseState,
  updateAds,
  locationsRegion,
                     selectedScope, clearScopeFilter, clearLocationFiler, setSubmitData, gtag4
}) => {
  const [filterScope, setFilterScope] = useState([]);
  const [filterLocation, setFilterLocation] = useState([]);
  const [hasCountFilterJob, setHasCountFilterJob] = useState(true);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedScopes, setSelectedScope] = useState([]);
  const handleScopeChecked = (key, event) => {
    updateScope({key, checked: event.target.checked});
  };
  const handleLocationChecked = (key, event) => {
    updateLocation({key, checked: event.target.checked});
  };

  const handleSelectLocation = () => {
    const selectedCities = locationCareersData.reduce((cities, region) => {
      if (region.checked && region.cities) {
        region.cities.forEach((city) => cities.push(city.name));
      }
      return cities;
    }, []);
    setSelectedCities(selectedCities);
    var isEmptyFilter = filterJobData[0] === 'SHOW_ALL';
    updateAds({
      selectedCities: selectedCities,
      adsCareers: adsCareersData,
      filterJob: isEmptyFilter ? [] : filterJobData,
      filterLocation: locationCareersData,
    });
  };
  const handleSelectScope = () => {
    const selectedScopes = careerScopeList
      .filter((scope) => {
        if (scope.checked) return scope.label;
      })
      .map((y) => y.label);
    setSelectedScope(selectedScope)
    var isEmptyFilter = filterJobData[0] === 'SHOW_ALL';
    updateAds({
      selectedScope: selectedScopes,
      adsCareers: adsCareersData,
      filterJob: isEmptyFilter ? [] : filterJobData,
      filterLocation: locationCareersData,
    });
  };

  const handleSelectScopeNone = () => {
    clearScopeFilter()

    var isEmptyFilter = filterJobData[0] === 'SHOW_ALL';

    updateAds({
      selectedScope: [],
      adsCareers: adsCareersData,
      filterJob: isEmptyFilter ? [] : filterJobData,
      filterLocation: locationCareersData,
    });
  };
  const handleSelectLocationNone = () => {
    var isEmptyFilter = filterJobData[0] === 'SHOW_ALL';
    updateAds({
      selectedCities: [],
      selectedScope: selectedScope,
      adsCareers: adsCareersData,
      filterJob: isEmptyFilter ? [] : filterJobData,
      filterLocation: locationCareersData,
    });
    clearLocationFiler()
  };

  const handleCollapse = (codeJob, location, isOpen) => {
    var isEmptyFilter = filterJobData[0] === 'SHOW_ALL';

    setCollapseState({codeJob: codeJob, location: location, isOpen: isOpen,isOnFilter: !isEmptyFilter});
  };

  const isNoneFilterOrSelected = () => {
    const isNoneFilter =
      selectedUtils?.length === 0 &&
      filterScope?.every((scope) => !scope.checked) &&
      filterLocation?.every((location) => !location.checked);
    setHasCountFilterJob(isNoneFilter);
  };

  useEffect(() => {
    isNoneFilterOrSelected();
  }, [selectedUtils, filterScope, filterLocation]);


  return (
    <>
      <div className={'careers_dropbox'}>
        <div className='careers-checkbox-dropdown-wrapper'>
          <div className={'careers-checkbox-dropdown'}>
            <CheckboxDropdown
              // count={locationCareersData?.filter((location) => location.checked).length}
              icon={LocationJobIcon}
              // title='מיקום'
              title={setFilterTitle('Location', locationsRegion ? locationsRegion.length : 0, locationsRegion)}
              locationsRegion={locationsRegion}
              items={locationCareersData}
              handleChecked={handleLocationChecked}
              handleSelectAll={handleSelectLocation}
              handleSelectNone={handleSelectLocationNone}
              type={"Location"}
            />
          </div>
          <div className={'careers-checkbox-dropdown'}>
            <CheckboxDropdown
              // count={careerScopeList.filter((scope) => scope.checked).length}
              icon={ScopeJobIcon}
              // title='היקף משרה'
               title={setFilterTitle("Scope",selectedScope ? selectedScope.length : 0,selectedScope)}
              items={careerScopeList}
              handleChecked={handleScopeChecked}
              handleSelectAll={handleSelectScope}
              handleSelectNone={handleSelectScopeNone}
              type={"Scope"}

            />
          </div>
        </div>
      </div>

      <div className={'careers-add-job'}>
        {!filterJobData.includes("SHOW_ALL") && (
          <div className='careers-add-job__frame'>
            <div className='careers-add-job__ad-frame'>
              <div className={'careers-find-job'}>
                <span>נמצאו {filterJobData.filter((ad) => !ad.isHiddenAd).length} משרות</span>
              </div>
            </div>
          </div>
        )}

        {filterJobData.length > 0 && filterJobData[0] !== 'SHOW_ALL' && (
          filterJobData.map((jobAd, index) => (
            !jobAd.isHiddenAd && (
              <div key={index} className='careers-add-job__frame'>
                <div className='careers-add-job__ad-frame'>
                  <CareersAdItem context={context} jobAd={jobAd} handleChangeCollapse={handleCollapse}
                                 setSubmitData={setSubmitData} gtag4={gtag4} cities={cities}/>
                </div>
              </div>
            )
          ))
        )}

        {filterJobData.length === 0 && <div className='careers-add-job__frame'></div>}

        {filterJobData.length > 0 && filterJobData[0] === 'SHOW_ALL' && (
          adsCareersData.map((jobAd, index) => (
            !jobAd.isHiddenAd && (
              <div key={index} className='careers-add-job__frame'>
                <div className='careers-add-job__ad-frame'>
                  <CareersAdItem context={context} jobAd={jobAd} handleChangeCollapse={handleCollapse}
                                 setSubmitData={setSubmitData} gtag4={gtag4} cities={cities}/>
                </div>
              </div>
            )
          ))
        )}
      </div>
    </>
  );
};

export default CareersAd;

const setFilterTitle = (type, count, payload) => {
  let title = '';
  switch (type) {
    case 'Location':
      if (payload?.length > 0 && payload.includes(99)) {
        title = "כל הארץ"
        break;
      }

      if (count === 1) {
        title = payload;
      } else {
        title = 'מיקום' + ' ' + '(' + count + ')';
      }
      break;
    case 'Scope':
      if (count === 1) {
        title = payload;
      } else {
        title = 'היקף משרה' + ' ' + '(' + count + ')';
      }
      break;
    default:
      break;
  }
  return title;
};
